export default __webpack_public_path__ + "static/media/Ramadan2023MobileBanner.a6efc794.jpg";